export default __webpack_public_path__ + "static/electric-dfsk-165646eac87065b6804f350595c35f99.png";